import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';

const createReactClass = require('create-react-class');

const RegionAndCountrySelect = createReactClass({
  getInitialState() {
    return {
      allCountries: [],
      allRegions: [],
      regionId: this.props.initialRegion,
      countryId: this.props.initialCountry
    };
  },
  getSelectedValues() {
    const region = this.state.allRegions.filter(
      function(region) {
        return region.id == this.state.regionId;
      }.bind(this)
    )[0];
    const country = this.state.allCountries.filter(
      function(country) {
        return country.id == this.state.countryId;
      }.bind(this)
    )[0];
    return {
      regionId: region ? region.id : null,
      regionAbbr: region ? region.abbr : null,
      countryId: country ? country.id : null,
      countryAbbr: country ? country.isoCode : null
    };
  },
  componentDidMount() {
    ServerCommunicationUtil.getApiEndpoint('/api/alltrails/countries', {}, this.handleCountryLoad, this.handleGetError, this.handleGetComplete);
  },
  handleGetError() {},
  handleGetComplete() {},
  handleCountryLoad(data) {
    if (data.countries.length > 0) {
      this.setState({ allCountries: data.countries });
      const country = data.countries.filter(ctry => {
        return ctry.id == this.state.countryId;
      })[0];
      if (country) {
        ServerCommunicationUtil.getApiEndpoint(`/api/alltrails/countries/${country.id}/regions`, {}, this.handleRegionLoad, this.handleGetError, this.handleGetComplete);
      }
    } else {
      this.setState({ allCountries: [] });
    }
  },
  handleRegionLoad(data) {
    if (data.regions.length > 0) {
      // var regions = data.regions.reduce(function(map, reg) {map[reg.abbr] = reg; return map;}, {});
      this.setState({ allRegions: data.regions });
    } else this.setState({ allRegions: [] });
  },
  handleCountryChange(e) {
    const countryId = e.currentTarget.value;
    const country = this.state.allCountries.filter(ctry => {
      return ctry.id == countryId;
    })[0];
    ServerCommunicationUtil.getApiEndpoint(`/api/alltrails/countries/${country.id}/regions`, {}, this.handleRegionLoad, this.handleGetError, this.handleGetComplete);
    this.setState({ countryId });
  },
  handleRegionChange(e) {
    const regionId = e.currentTarget.value;
    this.setState({ regionId });
  },
  generateRegionOption(region) {
    return <option value={region.id}>{region.name}</option>;
  },
  generateCountryOption(country) {
    return <option value={country.id}>{country.name}</option>;
  },
  render() {
    const countries = this.state.allCountries.map(this.generateCountryOption);
    const regions = this.state.allRegions.map(this.generateRegionOption);
    let className = 'half';
    if (this.state.allRegions.length == 0) className += ' hidden';
    return (
      <div>
        <select className={className} value={this.state.regionId} onChange={this.handleRegionChange}>
          <option value="">-- region --</option>
          {regions}
        </select>
        <select className="half" value={this.state.countryId} onChange={this.handleCountryChange}>
          <option value="">-- country --</option>
          {countries}
        </select>
      </div>
    );
  }
});

export { RegionAndCountrySelect };
